/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import { useResetPasswordFormState } from "../hooks/useResetPasswordFormState";
import { ResetPasswordForm } from "../components/ResetPasswordForm";
import { SiteLayout } from "../components/SiteLayout";
//import { useEffect } from "react";
import { useHookstateEffect } from "@hookstate/core";
import { useSearchParams } from "react-router-dom";
//import { useSiteLayoutState } from "../hooks/useSiteLayoutState";

export type ResetPasswordPageProps = {
    type: 'resetpassword' | 'completeregistration' | 'changepassword';
}
export const ResetPasswordPage: React.FC<ResetPasswordPageProps> = props => {
    const [searchParams/*, setSearchParams*/] = useSearchParams();
    const email = searchParams.get('email') || '';
    const token = searchParams.get('token') || '';

    const resetPasswordFormState = useResetPasswordFormState();

    useHookstateEffect(() => {
        resetPasswordFormState.setIsPopup(false);
        const newemail = searchParams.get('email') || '';
        const newtoken = searchParams.get('token') || '';

        //console.log('Reset Password:', search, email, token);
        if (newemail && newtoken) {
            //console.log(2)
            resetPasswordFormState.setEmail(newemail);
            resetPasswordFormState.setTemporaryPassword(newtoken);
        }
    }, [searchParams]);

    return (<SiteLayout
        title={resetPasswordFormState.translate('Reset Password')}
        mainChildren={
            <div css={css`
                flex:1 1 0;`}>
                <div css={css`
                    display:flex;
                    justify-content:center;
                    align-items:center;`}>
                    {email && token && (
                        <ResetPasswordForm type={props.type} />
                    )}
                </div>
            </div>
        }
    />);
}
